import React from "react";
import { useTranslation } from "react-i18next";
import passScenario from "@assessment/assets/certificateImg.svg";
import failScenario from "@assessment/assets/almostThere.svg";

interface CertificationResultScreenProps {
  passed: boolean;
  scheduleId: string;
  title: string | null;
}

export const CertificationResultScreen: React.FC<
  CertificationResultScreenProps
> = ({ passed, scheduleId, title }) => {
  const { t } = useTranslation();

  const onCompletionData = {
    img: passed ? passScenario : failScenario,
    text: passed ? (
      <>
        {t("assessment.resultCard.congratulationsOnEarning", {
          featureName: title || ""
        })}
      </>
    ) : (
      t("assessment.resultCard.almostThereTitle")
    ),
    subText: passed
      ? t("assessment.resultCard.certificatePassedDescription")
      : t("assessment.resultCard.certificateFailDescription")
  };
  return (
    <>
      <img
        src={onCompletionData.img}
        alt={
          passed
            ? t("assessment.resultCard.congratsImageAlt")
            : t("assessment.resultCard.almostThereImageAlt")
        }
        className="h-44"
      />
      <h1 className="text-2xl lg:text-[32px] leading-10 font-semibold text-secondary mt-10 mb-5">
        {onCompletionData.text}
      </h1>

      <p className="text-lg font-normal leading-6 md:text-xl text-secondary/50">
        {onCompletionData.subText}
      </p>
    </>
  );
};

export default CertificationResultScreen;
